// extracted by mini-css-extract-plugin
export default {"block":"qnQtkhoqEd4iN3BGCrlR"};